export default __webpack_public_path__ + "static/media/coin-into-upward-growth-box.a8135429.svg";